var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', _vm._b({
    ref: "body",
    staticClass: "d-flex flex-column fill-height",
    on: {
      "click": _vm.onClick
    }
  }, 'v-sheet', {
    style: _vm.style
  }, false), [_c('v-card-text', {
    staticClass: "d-flex justify-space-between"
  }, [_vm._t("head-left"), _c('v-spacer'), _c('body-head')], 2), _c('v-divider'), _c('v-card-text', {
    ref: "wrapper",
    staticClass: "scroll-primary pa-1 pa-sm-2 pa-md-4 grey lighten-5",
    staticStyle: {
      "flex": "1 1 auto",
      "overflow-x": "auto",
      "overflow-y": "auto"
    }
  }, [_c('v-row', {
    staticClass: "ma-n1 ma-sm-n2 ma-md-n4 flex-column",
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_vm._l(_vm.pages, function (page, pageIndex) {
    return [_c('v-col', {
      key: pageIndex,
      ref: `page-${pageIndex}`,
      refInFor: true,
      staticClass: "pa-1 pa-sm-2 pa-md-4",
      attrs: {
        "cols": "auto"
      }
    }, [_c('body-item', _vm._g(_vm._b({
      staticClass: "employment-doc-body__page",
      model: {
        value: _vm.items,
        callback: function ($$v) {
          _vm.items = $$v;
        },
        expression: "items"
      }
    }, 'body-item', {
      mode: _vm.mode,
      page,
      pageIndex
    }, false), {
      input: _vm.emit,
      setIndex: _vm.setIndex
    }))], 1)];
  })], 2)], 1), _c('body-tool', _vm._g(_vm._b({
    model: {
      value: _vm.items,
      callback: function ($$v) {
        _vm.items = $$v;
      },
      expression: "items"
    }
  }, 'body-tool', {
    mode: _vm.mode
  }, false), {
    input: _vm.emit
  })), _vm._t("default")], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }